import "./assets/main.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { createIconsConfig, createVuestic } from "vuestic-ui";
import "vuestic-ui/css";

// Importar íconos correctamente
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";
import router from "./router";

const app = createApp(App);

app.use(createPinia());
app.use(router);

// Configurar Vuestic UI con configuración mejorada
app.use(
  createVuestic({
    config: {
      colors: {
        primary: "#052A5B",
        secondary: "#424242",
        success: "#00C851",
        info: "#33B5E5",
        warning: "#FF8800",
        danger: "#FF4444",
        background: "#ffffff",
        "background-secondary": "#f8f9fa",
        "background-border": "#e9ecef",
      },
      icons: createIconsConfig({
        fonts: [
          {
            name: "{icon}",
            resolve: ({ icon }) => ({
              class: `mdi mdi-${icon.replaceAll("_", "-")}`,
            }),
          },
        ],
      }),
    },
  }),
);

app.mount("#app");
